import React, { useContext } from 'react'
import { ScenarioStatesProviderContext } from '../providers/StatesProvider'
import { ScheduleTaskType } from '../utils/scenario-types'

const useTimelineFilter = () => {
    const context = useContext(ScenarioStatesProviderContext)
    if (context === undefined) {
        throw new Error('useTimelineFilter must be used within a Scenario States Provider')
    }
    const { timelineFilter, setTimelineFilter } = context
    const { active, filter, placement } = timelineFilter

    const setSelectedFilter = (value: string) => {
        setTimelineFilter(prev => ({
            ...prev,
            filter: prev.filter.map(item => ({ ...item, selected: item.id === value }))
        }))
    }

    const setSelectedFilterOption = (filterId: string, value: string) => {
        setTimelineFilter(prev => ({
            ...prev,
            filter: prev.filter.map(item => {
                if (item.id !== filterId) return item
                if (value === 'All') {
                    return {
                        ...item,
                        selectedOptions: item.selectedOptions?.length === item?.filterOptions?.length ? [] : item.filterOptions
                    }
                }
                return {
                    ...item,
                    selectedOptions: item.selectedOptions.includes(value)
                        ? item.selectedOptions.filter(option => option !== value)
                        : [...item.selectedOptions, value]
                }
            })
        }))
    }

    const onActiveChange = () => {
        setTimelineFilter(prev => ({
            ...prev,
            active: !prev.active,
        }))
    }

    const resetTimelineFilter = (schedules: Record<string, ScheduleTaskType[]>, selectedSatellite?: string) => {
        const scheduleEvents = selectedSatellite ? schedules[selectedSatellite] || [] : []
        const tasks = Array.from(new Set(scheduleEvents.map(sc => sc.taskName).filter(Boolean)))
        const status = Array.from(new Set(scheduleEvents.map(sc => sc.status).filter(Boolean)))
        const type = Array.from(new Set(scheduleEvents.map(sc => sc.type).filter(Boolean)))

        const options = {
            'tasks': tasks,
            'task_schedule': status,
            'task_type': type,
        }
        setTimelineFilter(prev => ({
            ...prev,
            filter: prev.filter.map(item => {
                const currentOptions = options[item.id as keyof typeof options] || [];
                return {
                    ...item,
                    filterOptions: currentOptions,
                    selectedOptions: currentOptions
                }
            })
        }))
    }

    return {
        active,
        filter,
        placement,
        onActiveChange,
        setSelectedFilter,
        resetTimelineFilter,
        setSelectedFilterOption
    }
}

export default useTimelineFilter